//---------------------------------------------------------------------------------------------
// Description
//---------------------------------------------------------------------------------------------
export default function SheaHomesAPIService()
{
    var obj = {
        init: init,
        lookupDocumentByNodeGUID: lookupDocumentByNodeGUID
    };
    return obj;

    function init()
    {
    }

    function lookupDocumentByNodeGUID(nodeGUID, responseCallback)
    {
        httpGet('/sheahomesapi/kentico/document/' + nodeGUID, responseCallback);
    }

    function httpGet(url, callback) {
        const xhr = new XMLHttpRequest();
        xhr.onreadystatechange = () => {
            if (xhr.readyState === 4) {
                var json = JSON.parse(xhr.response);
                callback(json);
            }
        }
        xhr.open('GET', url, true);
        xhr.send('');
    }
};
